import { getFiscalYears } from 'helpers/FiscalYearHelper';
import { Profile } from 'models/profile';
import React from 'react';
import { useProfile, useUser } from 'models';
// const profile = new Profile();
// const user = new User();

const SelectFiscalYears = ({company, listFY, notGetCompanyFiscalYear, max, min}) => {
  const profile = useProfile()
  const user = useUser()

  var list = user.fiscal_years
  if(company){
    if(company.fiscal_years_elite) list = [...company.fiscal_years_elite];
    else if(company.group_years) list = [...company.group_years];
  }
  if(listFY){
    list = [...listFY];
  }
  let permission = profile.routes.filter((b)=>{
    return b.alias == 'all_fiscal_years.access'
  }).length > 0;

  list = list.filter((a)=>{
    if(permission) return true;
    return a.block === 0;
  });

  list.sort(function(a, b) {
    return b.fiscal_year-a.fiscal_year;
  });
  return list.filter((a)=>{
    let r = true;
    if(max){
      r = a.id <= max;
    }
    if(min && r){
      r = a.id >= min;
    }
    return r;
  }).map((a,k)=>{
    return <option key={k} value={a.id}>{'FY'+a.fiscal_year.slice(-2)}</option>
  });
}

const SelectFiscalYearsDefault = () => {
  const user = useUser()
  var list = user.fiscal_years;

  return list.map((a,k)=>{
    return <option key={k} value={a.id}>{'FY'+a.fiscal_year.slice(-2)}</option>
  });
}

SelectFiscalYears.propTypes = {
  notGetCompanyFiscalYear: false,
};
export {
  SelectFiscalYearsDefault
}

export default SelectFiscalYears;